(ns ui.popover
  (:require
   ["@radix-ui/react-popover" :as RadixPopover]
   [ui.dialog :refer [dialog-actions]]
   [ui.utils :refer [clsx separate-props]]))

(defn popover-close [& args]
  (let [[props children] (separate-props args)]
    (into [:> RadixPopover/Close (-> {:asChild true}
                                     (merge props))]
          children)))

(defn popover-anchor [& args]
  (let [[props children] (separate-props args)]
    (into [:> RadixPopover/Anchor props]
          children)))

(defn popover-trigger [& args]
  (let [[props children] (separate-props args)]
    (into [:> RadixPopover/Trigger props]
          children)))

(defn popover-root [& args]
  (let [[props children] (separate-props args)]
    (into [:> RadixPopover/Root props]
          children)))

(defn popover-arrow []
  [:> RadixPopover/Arrow {:fill "white" :class "shadow-xs dark:fill-kleene-dark-01"}])

(defn popover-content [& args]
  (let [[props children] (separate-props args)]
    [:> RadixPopover/Portal {:container (:container props)}
     (into [:> RadixPopover/Content
            (cond-> (dissoc props :container)
              (not (:sideOffset props))
              (assoc :sideOffset 5)

              true
              (update :class #(clsx "z-2000 shadow-lg rounded-md p-4 bg-white dark:bg-kleene-dark-01 ring-1 ring-black/5 radix-state-open:animate-fade-in" %)))
            [popover-arrow]]
           children)]))

(def popover-actions dialog-actions)

(defn popover [{:keys [content trigger-as-child close open on-open-change content-props props]
                :or   {trigger-as-child true
                       content-props {}
                       props {}}}
               trigger]
  [popover-root (merge props
                       (when-not (nil? open)
                         {:open open})
                       (when-not (nil? on-open-change)
                         {:on-open-change on-open-change}))
   [popover-trigger {:as-child trigger-as-child} trigger]

   [popover-content content-props
    content
    (when close [popover-close close])]])
